import { render, staticRenderFns } from "./DelegateModal.vue?vue&type=template&id=598ca718"
import script from "./DelegateModal.vue?vue&type=script&lang=js"
export * from "./DelegateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports